import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Description: 跨域提交数据引擎
 * @Author: suzyli
 * @Date: 2019-12-31 11:30:05
 * @LastEditTime: 2021-04-08 21:31:39
 */

/* global  EAS   */

/* eslint-disable import/no-duplicates */
import Login from '../biz/login';
import Engine from './engine';
import FormManager from '../util/form';
import ATM from '../util/atm';
import captcha from './captcha';
import url from '../common/url';
import cookie from '../common/cookie';
import urlHelper from '../common/url';
import platform from '../common/platform';
import { isFunction, isObject } from '../common/base';
/**
 * @description: 存储Engine.check的原始数据，供重发请求用
 */

var requestPoolData = {};
/**
 * @description: 自定义处理函数，不经过ame默认的处理
 */

var oSelfCallbacks = {};

var ameCSRFToken = function ameCSRFToken() {
  var sAMEStr = cookie.get('skey') || 'a1b2c3';
  var hash = 5381;

  for (var i = 0, len = sAMEStr.length; i < len; ++i) {
    hash += (hash << 5) + sAMEStr.charAt(i).charCodeAt();
  }

  return hash & 0x7fffffff;
}; // 过载保护检查


var safeGuard = function safeGuard(jsonData) {
  if (cookie.get('_AMSSafeguard')) {
    var sData = jsonData && jsonData.sData || {};
    var safeguardTips = sData.safeguardTips || '很抱歉当前访问人数过多,请稍后再试';

    if (!isFunction(sData.safeguardCallback)) {
      if (window.$alert) {
        window.$alert(safeguardTips);
      } else {
        alert(safeguardTips);
      }
    } else {
      sData.safeguardCallback();
    }
  }
}; // // pc端过载保护弹窗
// const pcSafeguard = function(safeguardTips) {
// 	//先关闭已经显示的层
// 	// Dialog.hide();
// 	//剩余过期时间
// 	var remainingTime = Math.ceil((cookie.get('_AMSSafeguard') - new Date().getTime())/1000);
// 	//判断是否已经存在提示层
// 	if(g('_AMSSafeguardTips')){
// 		// Dialog.show({id:'_AMSSafeguardTips'});
// 	}else{
// 		var tipsTPL = document.createElement('div'),
// 			closeBtn = document.createElement('span'),
// 			tipsTEXT_a = document.createTextNode(safeguardTips);
// 		tipsTPL.id = '_AMSSafeguardTips';
// 		tipsTPL.style.cssText = 'width:200px;height:40px;border:2px solid #389DD8; padding:15px 25px 25px 15px; background-color:#fff;font-size:14px;font-weight:bold; color:#389DD8;position:relative; _zoom:1;line-height:1.8';
// 		closeBtn.id = '_AMSSafeguardClose';
// 		closeBtn.innerHTML = '&times;';
// 		closeBtn.style.cssText = 'width:16px;height:16px;font-size:14px;line-height:1;position:absolute; top:5px; right:5px; color:#F56813;cursor:pointer;';
// 		tipsTPL.appendChild(closeBtn);
// 		tipsTPL.appendChild(tipsTEXT_a);
// 		document.body.appendChild(tipsTPL);
// 		// Dialog.show({id:'_AMSSafeguardTips'});
// 	}
// 	//绑定关闭tips层
// 	g('_AMSSafeguardClose').onclick = function(){
// 		// Dialog.hide();
// 	};
// 	//动态更新倒计时时间
// 	setTimeout(function() {
// 		// Dialog.hide();
// 	}, remainingTime * 1000)
// }


var amsGetFormatUrl = function amsGetFormatUrl(url) {
  var _url = url.toLowerCase();

  if (url.indexOf('?') != -1) {
    _url = url.substr(0, url.indexOf('?'));
  }

  if (_url.indexOf('#') != -1) {
    _url = _url.substr(0, _url.indexOf('#'));
  }

  _url = _url.replace('index.shtml', '').replace('index.html', '').replace('index.htm', '').replace('index.php', '');

  var arrUrl = _url.split('/');

  var LastStr = arrUrl[arrUrl.length - 1];

  if (LastStr != '' && LastStr != undefined && LastStr.indexOf('.shtml') == -1 && LastStr.indexOf('.html') == -1 && LastStr.indexOf('.htm') == -1 && LastStr.indexOf('.php') == -1) {
    _url = "".concat(_url, "/");
  }

  _url = _url.replace('https://', 'http://');
  return _url;
};
/**
 * @description: 数据预处理
 */


var preProcess = function preProcess(data) {
  // sData做一个校验
  if (!isObject(data.sData)) {
    alert('额外参数需要是一个object');
    return;
  } // 判断活动号、流程号是否正常，不正常则退出


  if (data.iActivityId == -1 || data.iFlowId == -1) {
    return;
  }

  var retData = data;
  retData.sData = _objectSpread(_objectSpread({}, retData.sData), {}, {
    iActivityId: data.iActivityId,
    iFlowId: data.iFlowId,
    g_tk: ameCSRFToken()
  });
  var LoginManager = new Login();

  if (platform.isMobile() && LoginManager.isMSDKLogin()) {
    var msdkData = LoginManager.getMSDKParams();
    retData.sData = _objectSpread(_objectSpread({}, retData.sData), msdkData);
  } // 对sData的数据encode


  for (var i in retData.sData) {
    var newJsonObj = retData.sData[i];

    if (typeof newJsonObj === 'undefined' || typeof newJsonObj === 'function') {
      newJsonObj = '';
    }

    if (typeof newJsonObj === 'string') {
      retData.sData[i] = encodeURIComponent(newJsonObj);
    }
  }

  retData.g_tk = ameCSRFToken(); // if(!isFunction(data.fFlowSubmitEnd)){
  // 	retData.fFlowSubmitEnd = function(res){
  // 		alert(res.sMsg);
  // 	};
  // }
  // 整理传入的form表单数据

  if (retData.sFormName) {
    var fillData = FormManager.getAllInputValue(retData.sFormName) || {};
    retData.sData = _objectSpread(_objectSpread({}, retData.sData), fillData);
  } // lealwang(王方晓) 2015-05-21  这边为了追踪渠道效果，会在活动页面的url上加两个参数 e_code=xxx&g_code=xxxx
  // 你这边的往后端AME请求的时候，能带上这两个参数吗（如果有就取值，没有就都设为0）


  var extCodeData = {
    e_code: url.request('e_code') || 0,
    g_code: url.request('g_code') || 0,
    eas_url: encodeURIComponent(amsGetFormatUrl(document.location.href)),
    eas_refer: encodeURIComponent(amsGetFormatUrl(document.referrer))
  }; // 使用EAS库获取相关EAS参数

  try {
    if (window.EAS) {
      extCodeData = {
        e_code: EAS.GetECodeExt(),
        g_code: EAS.GetGCodeExt(),
        eas_url: EAS.GetLogUrlExt(),
        eas_refer: EAS.GetReferrerUrlExt()
      };
    }
  } catch (e) {//
  }

  retData.sData = _objectSpread(_objectSpread({}, retData.sData), extCodeData);
  return retData;
};
/**
 * @description: 发送ams请求
 * @param {object} data
 * @return:null
 */


var submit = function submit(jsonData) {
  return new Promise(function (resolve, reject) {
    // 过载保护检查
    if (cookie.get('_AMSSafeguard')) {
      safeGuard(jsonData);
      reject();
    }

    var opt = preProcess(jsonData);

    if (isFunction(opt.fFlowSubmitPre) && opt.fFlowSubmitPre()) {
      reject();
    }

    var self = new FlowEngine(opt);
    var fl = new Engine(opt);

    if (!self.amsActDesc || !self.amsActDesc.iActivityStatus) {
      alert('活动不在开启状态');
    }

    self.checkSetting().then(function () {
      // 大区绑定回调 用于抽奖 add susahuang 15.12.2
      if (isFunction(self.flowJsonData.onGetAreaFinishedEvent)) {
        self.flowJsonData.onGetAreaFinishedEvent();
      }

      var iFlowId = fl.flowJsonData.iFlowId;
      var iActivityId = fl.flowJsonData.iActivityId;
      requestPoolData[iFlowId] = fl; // 判断是否需要加防刷

      captcha.judgeCap(iActivityId, iFlowId, function (res) {
        if (res) {
          if (fl.flowJsonData.sData) {
            fl.flowJsonData.sData.capTicket = res.ticket;
            fl.flowJsonData.sData.capRandstr = res.randstr;
          } else {
            fl.flowJsonData.sData = {
              capTicket: res.ticket,
              capRandstr: res.randstr
            };
          }
        } // 发送flowengine请求


        fl.request().then(function (data) {
          // if(Dialog.id == '_PopupMsg_'){
          // 	Dialog.hide();
          // }
          // 判断是否自定义处理返回【不使用默认的flowengine】
          if (oSelfCallbacks[iFlowId] && isFunction(oSelfCallbacks[iFlowId])) {
            oSelfCallbacks[iFlowId](data);
            resolve(data);
          } // 过载保护


          if (data && data.msg.indexOf('An error occurred. 503') != -1) {
            cookie.set('_AMSSafeguard', new Date().getTime() + 30 * 1000, 30, window.location.host, '/', false);
            safeGuard();
            var ameurl = '';

            if (_typeof(window["ams_actdesc_".concat(fl.flowJsonData.iActivityId)]) === 'object') {
              ameurl = window["ams_actdesc_".concat(fl.flowJsonData.iActivityId)].sAmePcUrl;
            }

            ATM.reportATM({
              toappid: 1,
              tomoduletype: ameurl,
              tointer: 1,
              toreturncode: 1,
              businesstype: fl.flowJsonData.sData.sServiceType,
              result: '503',
              serialnum: '',
              actid: fl.flowJsonData.iActivityId,
              errormsg: '很抱歉当前访问人数过多,请稍后再试',
              timecost: Engine.timecost.getTimeCost(self.flowJsonData.iFlowId)
            });
            reject();
          }

          self.amsFlowBack(data, iFlowId, iActivityId).then(function (res) {
            resolve(res);
          })["catch"](function (err) {
            reject(err);
          });
        })["catch"](function (err) {
          console.log('err', err);
        });
      });
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var loginErrorCallback = function loginErrorCallback() {
  var LoginManager = new Login();
  LoginManager.logout(function () {
    if (window.$alert) {
      window.$alert('您登录时间过长，请重新登录后再参与活动');
    } else {
      alert('您登录时间过长，请重新登录后再参与活动~');
    }
  });
};
/**
 * @description: 允许设置自定义登录失败回调
 * @param {type}
 * @return:
 */


var setLoginErrorCallback = function setLoginErrorCallback(callback) {
  if (isFunction(callback)) {
    loginErrorCallback = callback;
  }
};
/**
 * @description: 设置需要自定义处理的流程
 * @param {number} iFlowId
 * @param {function} callback
 */


var setSelfCallback = function setSelfCallback(iFlowId, callback) {
  oSelfCallbacks[iFlowId] = callback;
};

var FlowEngine = /*#__PURE__*/function () {
  function FlowEngine(opt) {
    _classCallCheck(this, FlowEngine);

    var defaultFlowData = {
      sUrl: "".concat(location.protocol, "//apps.game.qq.com/ams/ame/ame.php?ameVersion=0.3"),
      sData: {},
      // 传递额外参数
      sFormName: '',
      fFlowSubmitPre: null,
      // 返回ture或flase
      fFlowSubmitEnd: null,
      // (成功后会把成功的信息返回给这个函数，这个函数处理由模块自己完成)
      fFlowSubmitFailed: null,
      // 失败会走到这个函数
      fFlowProssFailed: null,
      // 程序处理失败iRet<0
      objCustomFun: null,
      // 失败会走到这个函数
      sNeedSubmitPopDiv: true // 提交数据的loading层

    };
    var LoginManager = new Login();

    if (platform.isMobile()) {
      defaultFlowData = _objectSpread(_objectSpread({}, defaultFlowData), {}, {
        sData: {
          appid: urlHelper.request('appid') || '',
          sArea: urlHelper.request('areaid') || '',
          sPlatId: urlHelper.request('platid') || '',
          sPartition: urlHelper.request('partition') || ''
        },
        isMSDK: LoginManager.isMSDKLogin(),
        // 判断是MSDK跳转
        isWX: !!(urlHelper.request('appid') && urlHelper.request('wxcode') && urlHelper.request('iswxmp') == 1) // 判断是weixin跳转

      });
    } // 注意！这里是浅拷贝


    this.flowJsonData = _objectSpread(_objectSpread({}, defaultFlowData), opt);
    this.iActivityId = this.flowJsonData.iActivityId;
    this.iFlowId = this.flowJsonData.iFlowId;
    this.amsActDesc = window["ams_actdesc_".concat(this.iActivityId)] || {};
    this.flowObj = this.amsActDesc.flows && this.amsActDesc.flows["f_".concat(this.iFlowId)] || {};
  }
  /**
     * @description: OpenToOpen功能，openid转换用
     */


  _createClass(FlowEngine, [{
    key: "getOpenToOpen",
    value: function getOpenToOpen() {
      var self = this;
      var openToOpenObj = {
        oGopenidParams: {}
      };
      var iActivityId = self.flowJsonData.iActivityId;
      var iFlowId = self.flowJsonData.iFlowId;
      var amsActdesc = window["ams_actdesc_".concat(iActivityId)];
      var flowObj = amsActdesc.flows["f_".concat(iFlowId)];

      try {
        /*
        Step1:先判断账号类型决定是否走GOpenid相关逻辑
        */
        // 需要转换Gopenid
        if (5 == amsActdesc.sAccountType) {
          openToOpenObj.oGopenidParams.needGopenid = 1;
        } // Gopenid带注册


        if (7 == amsActdesc.sAccountType) {
          openToOpenObj.oGopenidParams.needGopenid = 1;
          openToOpenObj.oGopenidParams.isPreengage = 1;
        }
        /*
        Step2:托管转换相关逻辑
        */


        openToOpenObj.iActivityId = iActivityId; // 优先取sData中的targetAppId

        if (self.flowJsonData.sData.ams_targetappid_wx || self.flowJsonData.sData.ams_targetappid_qc) {
          openToOpenObj.ams_appname = self.flowJsonData.sData.ams_appname || '';
          openToOpenObj.ams_targetappid_wx = self.flowJsonData.sData.ams_targetappid;
          openToOpenObj.ams_targetappid_qc = self.flowJsonData.sData.ams_targetappid_qc;
          openToOpenObj.sAMSTrusteeship = self.flowJsonData.sData.sAMSTrusteeship || 0;
        } else {
          if ('object' === _typeof(flowObj.openToOpen)) {
            // 判断是否是对象
            if (
            /* flowObj.openToOpen.appName && */
            flowObj.openToOpen.targetAppId) {
              // 判断是否有值
              openToOpenObj.ams_appname = flowObj.openToOpen.appName || '';
              openToOpenObj.ams_targetappid_wx = flowObj.openToOpen.targetAppId;
              openToOpenObj.ams_targetappid_qc = flowObj.openToOpen.targetQQAppId;
              openToOpenObj.sAMSTrusteeship = amsActdesc.sAMSTrusteeship || 0;
            }
          }
        }
      } catch (e) {
        console.warn && console.warn('[FlowEngine.getOpenToOpen]', e);
      }

      return openToOpenObj;
    }
    /**
       * @description: 获取sRoleInfoUrl ，即角色查询的实际请求地址(上云用)
       */

  }, {
    key: "getRoleInfoUrl",
    value: function getRoleInfoUrl() {
      var iActivityId = this.flowJsonData.iActivityId;
      var amsActdesc = window["ams_actdesc_".concat(iActivityId)];

      if (amsActdesc && amsActdesc.sRoleInfoUrl) {
        return "".concat(location.protocol, "//").concat(amsActdesc.sRoleInfoUrl);
      }

      return '';
    }
  }, {
    key: "checkSetting",
    value: function checkSetting() {
      var self = this;
      return new Promise(function (resolve, reject) {
        var _ref = self.flowObj || {},
            iNeedLogin = _ref.iNeedLogin;

        var LoginManager = new Login(); // 是否需要登录

        if (iNeedLogin == '1' || self.flowJsonData.isMSDK || self.flowJsonData.isWX) {
          LoginManager.checkLogin().then(function () {
            resolve(self.checkRoleInfo());
          })["catch"](function (err) {
            console.log(err); // LoginManager.login()
            // alert('您当前未登录或登录态已过期，请先登录')

            reject(err);
          });
        } else {
          resolve(self.checkRoleInfo());
        }
      });
    }
  }, {
    key: "checkRoleInfo",
    value: function checkRoleInfo() {
      var _this$flowJsonData = this.flowJsonData,
          _this$flowJsonData$sD = _this$flowJsonData.sData,
          sData = _this$flowJsonData$sD === void 0 ? {} : _this$flowJsonData$sD,
          isBindAreaFlow = _this$flowJsonData.isBindAreaFlow;

      var _ref2 = this.flowObj || {},
          iNeedAreaRole = _ref2.iNeedAreaRole;

      var self = this;
      return new Promise(function (resolve, reject) {
        if (typeof iNeedAreaRole === 'undefined') {
          reject('iNeedAreaRole不存在，请检查配置');
        } // 检查角色, 是绑定大区流程，已经有角色了


        if (isBindAreaFlow == true || sData.sRoleId) {
          resolve();
        }

        if (iNeedAreaRole == '1') {
          // 检查绑定大区信息，从绑定大区获取角色信息
          if (!sData.sServiceType) {
            sData.sServiceType = self.amsActDesc.sServiceType;
          }

          var bindAreaInfo = window["BindAreaInfo_".concat(self.amsActDesc.iAreaRoleModId)];

          if (bindAreaInfo && bindAreaInfo.iRet == '0') {
            resolve();
          } else {
            if (sData.closeBindArea) {
              resolve();
            }

            var bindAreaTipsMsg = sData.bindAreaTipsMsg || '请先绑定大区 然后再继续操作！'; // alert(decodeURIComponent(bindAreaTipsMsg));

            reject({
              errCode: 2,
              // 2：需要绑定大区
              errMsg: bindAreaTipsMsg,
              areaBindOption: {
                iActivityId: self.flowJsonData.iActivityId,
                iFlowId: self.amsActDesc.iAreaRoleFlowId
              }
            });
          }
        } else if (iNeedAreaRole === '2' || iNeedAreaRole === '3') {
          // 检查登录信息，已登录弹出角色选择框，未登录则弹出登录
          var LoginManager = new Login();
          LoginManager.checkLogin().then(function () {
            var gameId = self.flowObj.iNeedAreaRoleService || self.amsActDesc.sServiceType;

            if (iNeedAreaRole === '3') {
              gameId = self.flowJsonData.sData.serviceType;
            }

            var roleselectorParam = {
              type: 'float',
              gameId: gameId,
              isShutdownSubmit: false,
              openToOpen: self.getOpenToOpen(),
              // openId转换参数
              sRoleInfoUrl: self.getRoleInfoUrl(),
              // 上云请求地址
              iActivityId: self.iActivityId
            };
            reject({
              errCode: 3,
              errMsg: '请先选择角色',
              rsOption: roleselectorParam
            });
          })["catch"](function () {
            reject({
              errCode: 1,
              errMsg: '请先登录'
            });
          });
        } else {
          // 不需角色信息
          if (!sData.sServiceType) {
            sData.sServiceType = self.amsActDesc.sServiceType;
          }

          resolve();
        }
      });
    }
  }, {
    key: "amsFlowBack",
    value: function amsFlowBack(sData, iFlowId, iActivityId) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var objData = sData; // try {
        // 	objData = Object.stringToJson(sData);
        // } catch (e) {
        // 	alert('当前访问人数过多，请稍后再试！');
        // }

        var ameurl = _this.amsActDesc && _this.amsActDesc.sAmePcUrl || '';
        var atmCfg = {
          toappid: 1,
          tomoduletype: ameurl,
          tointer: 1,
          businesstype: _this.flowJsonData.sData.sServiceType,
          result: objData.flowRet.iRet,
          serialnum: objData.flowRet.sLogSerialNum,
          actid: _this.flowJsonData.iActivityId,
          errormsg: objData.flowRet.sMsg // timecost: Engine.timecost.getTimeCost(self.flowJsonData.iFlowId)

        };
        var sNum = objData.flowRet.iRet;
        var failedRetArr = [];

        if (sNum == 0) {
          if (_this.flowJsonData.fFlowSubmitEnd) {
            _this.flowJsonData.fFlowSubmitEnd(objData.modRet, failedRetArr);
          }

          ATM.reportATM(_objectSpread(_objectSpread({}, atmCfg), {}, {
            toreturncode: 0 // report success

          }));
          resolve(objData.modRet);
        }

        if (sNum < 0) {
          ATM.reportATM(_objectSpread(_objectSpread({}, atmCfg), {}, {
            toreturncode: 1 // report failure

          }));
          reject(objData);
        } // 处理失败的信息


        if (objData.failedRet) {
          for (var i in objData.failedRet) {
            failedRetArr.push(objData.failedRet[i]);
          }

          objData.flowRet.failedRet = failedRetArr;
        }

        if (sNum > 0) {
          ATM.reportATM(_objectSpread(_objectSpread({}, atmCfg), {}, {
            toreturncode: 1 // report failure

          }));

          if (sNum == '110') {
            var sIsPeakName = "".concat(_this.iActivityId, "_ame_peak");
            cookie.set(sIsPeakName, 'isPeak', 2);
          }

          if (sNum == '101') {
            isFunction(loginErrorCallback) && loginErrorCallback(iActivityId, iFlowId);
          } // 要续期


          if (sNum == '201') {
            var LoginManager = new Login();
            LoginManager.refreshWegame(function () {
              // 续期成功
              var _fl = requestPoolData[iFlowId];

              if (_fl) {
                return _fl.request();
              }
            }, function () {
              // 续期失败
              reject(objData);
            });
            return;
          } // 501 防刷命中


          if (sNum == '501') {
            captcha.doCap(iActivityId, iFlowId, function (res) {
              var _fl = requestPoolData[iFlowId];

              if (_fl && res) {
                if (_fl.flowJsonData.sData) {
                  _fl.flowJsonData.sData.capTicket = res.ticket;
                  _fl.flowJsonData.sData.capRandstr = res.randstr;
                } else {
                  _fl.flowJsonData.sData = {
                    capTicket: res.ticket,
                    capRandstr: res.randstr
                  };
                }

                return _fl.request();
              }
            });
            return;
          }

          reject(objData.flowRet);
        }
      });
    }
  }]);

  return FlowEngine;
}();

export default {
  submit: submit,
  setLoginErrorCallback: setLoginErrorCallback,
  setSelfCallback: setSelfCallback
};